// extracted by mini-css-extract-plugin
export default {"button":"AuthActions_button__wR5E-","error":"AuthActions_error__VoLf0","disabled":"AuthActions_disabled__IyASi"};